import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

@Directive({
  selector: '[custom-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true }]
})
export class CustomValidatorDirective implements Validator {

  private _onChange: () => void;

  private _validator: ValidatorFn;
  public get validator(): ValidatorFn { return this._validator; }
  @Input("custom-validator")
  public set validator(value: (control: AbstractControl) => ValidationErrors | null) {
    this._validator = value;
    if (this._onChange) this._onChange();
  }

  validate(c: AbstractControl): { [key: string]: any; } {
    return this.validator ? this.validator(c) : null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/directives/custom-validator.directive.ts